import generateAsyncRouteComponent from '../generateAsyncRouteComponent';

export default {
  path: 'bra-fit-finder',
  component: generateAsyncRouteComponent({
    loader: () => import('./containers/SizeQuizPageContainer'),
  }),
};
